

import { NavLink } from "react-router-dom";
import sumero from './Logo.png'

function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top shadow">
      <div className="container">

        {/* Brand with icon */}
        <NavLink className="navbar-brand fw-bold" to="/">
          <i className="bi bi-code-slash me-2"></i>
          <img src={sumero} alt="logo" style={{ width: "25%" }}/>
        </NavLink>

        {/* Toggle Button */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarContent"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarContent">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-lg-center">

            <li className="nav-item">
              <NavLink className="nav-link" to="/">
                <i className="bi bi-house-door me-1"></i> Home
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link " to="/about">
                <i className="bi bi-info-circle me-1"></i> About us
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/Product">
                <i className="bi bi-info-circle me-1"></i> Product
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/Gallery">
                <i className="bi bi-info-circle me-1"></i> Gallery
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/contactus">
                <i className="bi bi-info-circle me-1"></i> Contact us
              </NavLink>
            </li>

            {/* Services Dropdown */}
            {/* <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="/"
                role="button"
                data-bs-toggle="dropdown"
              >
                <i className="bi bi-briefcase me-1"></i> Services
              </a>
              <ul className="dropdown-menu dropdown-menu-dark">
                <li><NavLink className="dropdown-item" to="/web">Web Dev</NavLink></li>
                <li><NavLink className="dropdown-item" to="/design">UI/UX</NavLink></li>
                <li><NavLink className="dropdown-item" to="/seo">SEO</NavLink></li>
              </ul>
            </li> */}

            {/* Login Button */}
            {/* <li className="nav-item ms-lg-3">
              <NavLink className="btn btn-outline-light btn-sm" to="/login">
                <i className="bi bi-box-arrow-in-right me-1"></i> Login
              </NavLink>
            </li> */}

            {/* Free Quote Button */}
            <li className="nav-item ms-lg-3">
              <NavLink className="btn btn-warning btn-sm text-dark" to="/Contactus">
                Free quote
              </NavLink>
            </li>

            {/* Profile Dropdown */}
            {/* <li className="nav-item dropdown ms-lg-3">
              <a className="nav-link dropdown-toggle d-flex align-items-center" href="/" role="button"data-bs-toggle="dropdown">
                <i className="bi bi-person-circle fs-5"></i>
              </a>

              <ul className="dropdown-menu dropdown-menu-end">
                <li><NavLink className="dropdown-item" to="/profile">Profile</NavLink></li>
                <li><NavLink className="dropdown-item" to="/settings">Settings</NavLink></li>
                <li><hr className="dropdown-divider" /></li>
                <li><NavLink className="dropdown-item text-danger" to="/logout">Logout</NavLink></li>
              </ul>
            </li> */}

          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;

